//@flow

import React from "react";
import classnames from "classnames";

import { ReactComponent as CheckedCategory } from "Commons/Assets/icons/check_simple_green.svg";

import { read } from "modules/ShortForm/misc/utilities";

type Props = {
  categoryType?: string,
  setCategoryType: Function,
  step: number,
  glossary: any,
  inheritedStyles: any,
};

const CategoryType = ({
  categoryType,
  inheritedStyles,
  setCategoryType,
  step,
  glossary: { electricity, gas },
}: Props) => {
  const isElectricity = categoryType === electricity.uCase;
  const isGas = categoryType === gas.uCase;
  const isStepOnePassed = step > 1;

  return (
    <div className={classnames("theme-border-color-primary", inheritedStyles.categoryTabContainer)}>
      <button
        className={classnames(
          "theme-color-primary",
          inheritedStyles.tab,
          inheritedStyles.left,
          { [inheritedStyles.active]: isElectricity },
          { ["theme-bgcolor-primary"]: isElectricity },
          { [inheritedStyles.disabled]: isStepOnePassed && !isElectricity }
        )}
        onClick={() => setCategoryType(electricity.uCase)}
        disabled={isStepOnePassed && !isElectricity}
      >
        <div className={classnames("theme-border-color-primary", inheritedStyles.checkbox)}>
          {isElectricity && <CheckedCategory />}
        </div>
        <span className={inheritedStyles.text}>{read(electricity.trans)}</span>
      </button>
      <button
        className={classnames(
          "theme-color-primary",
          inheritedStyles.tab,
          inheritedStyles.right,
          { [inheritedStyles.active]: isGas },
          { ["theme-bgcolor-primary"]: isGas },
          { [inheritedStyles.disabled]: isStepOnePassed && !isGas }
        )}
        onClick={() => setCategoryType(gas.uCase)}
        disabled={isStepOnePassed && !isGas}
      >
        <div className={inheritedStyles.checkbox}>{isGas && <CheckedCategory />}</div>
        <span className={inheritedStyles.text}>{read(gas.trans)}</span>
      </button>
    </div>
  );
};

export default CategoryType;
